import {Component, ViewChild} from '@angular/core';

import { BaseModal } from '../modals/modal-base';
import { ProgressBoxComponent } from '../progress/progress-box.component';
import {ModalService} from '../modals/modal.service';


@Component({
    selector: 'modal-loading',
    templateUrl: './modal-loading.component.html',
    styleUrls: ['./modal-loading.component.scss']
})
export class LoadingModal extends BaseModal<string> {

    @ViewChild('progress') private progressBoxComponent: ProgressBoxComponent;
    message: string;
    showStopTest: boolean = true;
    showOkButton: boolean = false;

    constructor(private modalService: ModalService) {
        super();
        this.message = '';
    }

    onActivate(message: string) {
        if(message !== 'Stopped'){
            this.progressBoxComponent.initProgress();
        }

        this.message = message;

    }

    updateDialog(message: string) {
        this.message = message;
    }

    onClose() {
        this.progressBoxComponent.stopProgress();
    }

    onStopTest() {
        this.modalService.stopTest();
    }

    onOkClick() {
        this.modalService.okClicked();
        this.closeDialog();
    }

    setShowStopTest(value: boolean) {
        this.showStopTest = value;
    }

    setShowOkButton(value: boolean) {
        this.showOkButton = value;
        if(value) {
            this.progressBoxComponent.stopProgress();
            this.progressBoxComponent.stopProgress();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modals/modal-loading.component.ts